import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { JwtService } from 'src/app/shared/services/jwt/jwt.service';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private sbUrl = environment.do_services_sb_url;
  private loginPopupMessageUrl = 'notifications/getNotifications';

  constructor(private http: HttpClient, private jwtService: JwtService) { }

  getLoginPopupMessage(body: any, selectedLanguage: any): Observable<string> {
    const encodedRequest = this.jwtService.encode(body, 'secret');
    return this.http.post(this.sbUrl + this.loginPopupMessageUrl, encodedRequest, { responseType: 'text' }).pipe(
      map((response: any) => this.extractMessage(response, selectedLanguage)),
      catchError((error: any) => throwError(() => error))
    );
  }

  private extractMessage(response: any, selectedLanguage: any): string {
 

    const decodedPayload = jwt_decode<any>(response);
    const notifications = decodedPayload?.notifications;
    const messageDesc = notifications?.messageDesc;

    if(!messageDesc || typeof messageDesc !== 'object') {
      return '';
    }

    const language = (selectedLanguage || 'en').toLowerCase();



    const message = messageDesc[language] || messageDesc.en || messageDesc.fr;
    
    return message || '';

  }


}
